var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart",style:({ width : _vm.width, height: _vm.height}),attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }